import { render, staticRenderFns } from "./ElectionEditDialog.vue?vue&type=template&id=dc74bd7c&scoped=true"
import script from "./ElectionEditDialog.vue?vue&type=script&lang=js"
export * from "./ElectionEditDialog.vue?vue&type=script&lang=js"
import style0 from "./ElectionEditDialog.vue?vue&type=style&index=0&id=dc74bd7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc74bd7c",
  null
  
)

export default component.exports